
/*
 *
 *@description:认证相关
 *@modifyContent:
 *@author: qiuhongyang
 *@date: 2020-07-28 17:32:50
 *
*/

interface rz_data {
    OrganizationType: string;
    QualificationInfo: string;
    qualificationInfo_Zmt: string;
    qualificationInfo_GX: string;
    BigVip: number;
    IsCompanyAccount:boolean,
    isCompanyAccount:boolean
}

interface identifyData {
    icons: string[];
    infos: string[];
}

//个人信息模态框认证是独立的

/**
    * 获取认证相关数据
    * 先判断bigvip=1 再根据OrganizationType判断是蓝V还是橙V
    * 再用 organizationtype 字段判断下是个人（001开头）还是非个人
    * 个人（最多三种）：1. 身份认证 qulificationinfo 字段 字段有值就显示 没值不加(黄V)
    *                 2. 自媒体认证 qualificationInfo_Zmt 字段有值就显示 没值不加(黄V)
    *                 3. 个性认证 qualificationInfo_GX 字段有值就加 没值不显示(红星)
    * 企业（就一种认证）：直接显示 qulificationinfo 字段 即可(蓝V)
    * 
    * @return {icons,infos}
*/

function identify(data: rz_data): identifyData {
    let result: identifyData = {
        icons: [],
        infos: []
    };
    if (!(data && data.BigVip === 1 && data.OrganizationType)) {
        return result;
    }
    let isPerson: boolean = /^001/.test(data.OrganizationType); //是否是个人
    // let isCampany:boolean = /^002/.test(data.OrganizationType); //是否是企业

    //个人
    if (isPerson) {

        let infoArr = [];
        // 身份认证
        if (data.QualificationInfo) {
            infoArr.push(data.QualificationInfo)
            result.infos.push(`${data.QualificationInfo}`)
        }
        // 自媒体认证
        if (data.qualificationInfo_Zmt) {
            infoArr.push(data.qualificationInfo_Zmt)
            result.infos.push(`<span>${data.qualificationInfo_Zmt}</span>`)
        }
        // 黄v 身份认证 或 自媒体
        if (data.QualificationInfo || data.qualificationInfo_Zmt) {
            result.icons.push(`<i class="icon icon_vip" title=" ${infoArr.join('、')}"></i>`)
        }
        // result.icons.push(`<i class="icon icon_vip" title=" ${infoArr.join('、')}"></i>`)
        // 个性认证
        if (data.qualificationInfo_GX) {
            result.icons.push(`<i class="icon icon_wh" title="${data.qualificationInfo_GX}"></i>`);
            result.infos.push(`<span>${data.qualificationInfo_GX}</span>`)
        }
    } else {
        //企业
        if (data.OrganizationType == "003006" && (!!data.IsCompanyAccount || !!data.isCompanyAccount)) {
            result.icons.push(`<i class="icon icon_vip_qiye" title="${data.QualificationInfo}"></i>`)
            result.infos.push(`${data.QualificationInfo || ""}`)
        }
        else {
            result.icons.push(`<i class="icon icon_vip_blue" title="${data.QualificationInfo}"></i>`)
            result.infos.push(`${data.QualificationInfo || ""}`)
        }
    }
    return result;
}


export default identify;